'use client';

import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import { AppConfigSlice, createAppConfigSlice } from './slices/app';
const useAppState = create<AppConfigSlice>()(
  persist(
    (...p) => ({
      ...createAppConfigSlice(...p),
    }),
    {
      name: 'com.chenxirenli---admin.salary',
      partialize: (state) =>
        Object.fromEntries(Object.entries(state).filter(([key]) => !['config'].includes(key))),
    },
  ),
);

export default useAppState;
